import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static values = { text: String }

  copy() {
    navigator.clipboard.writeText(this.textValue).then(() => {
      const button = this.element.querySelector('button') || this.element
      const original = button.textContent
      button.textContent = 'Copied!'
      setTimeout(() => {
        button.textContent = original
      }, 2000)
    })
  }
}
